<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add to Video</p>
        <button @click="close()" class="delete"></button>
      </header>
      <section class="modal-card-body">

        <h2 class="title is-2">Videos</h2>
        <ul v-if="sortedVideos.length > 0">
          <VideoModalVideo v-for="video in sortedVideos"
            @close="close()"
            :key='video.id'
            :id="video.id"
            :title="video.title"
            :fileID="resource"
            :cycleID="video.cycle"
          />
        </ul>
        <p v-else>
          No videos found.
        </p>

      </section>
      <footer class="modal-card-foot">
      </footer>
    </div>
  </div>
</template>

<script>
import store from '../store.js'
import VideoModalVideo from './VideoModalVideo.vue'

export default {
  name: 'AddtoVideoModal',
  props: {
    resource: {
      type: Number,
      required: true,
    },
  },
  components: {
    VideoModalVideo,
  },
  computed: {
    sortedVideos () {
      return store.state.videos
    },
  },
  methods: {
    close () {
      this.$emit('close')
    },
  },
}

</script>



// WEBPACK FOOTER //
// AddtoVideoModal.vue?29ce9d16